// src/pages/About/AboutUsPage.tsx
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { motion } from "framer-motion";

export default function AboutUsPage() {
    return (
        <div className="container mx-auto px-6 py-16 space-y-12">
            <section className="text-center space-y-4">
                <motion.h1
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="text-4xl font-bold tracking-tight text-primary"
                >
                    About IDSCRM
                </motion.h1>
                <p className="text-muted-foreground max-w-3xl mx-auto">
                    IDSCRM — Integrated Dealer Solutions — is the evolution of dealership technology.
                    Built from years of real-world automotive, finance, and software experience,
                    IDSCRM is a next-generation Dealer Operating System that unifies every corner
                    of your dealership — sales, finance, inventory, service, and customer experience —
                    under one connected platform.
                </p>
            </section>

            <section className="grid md:grid-cols-3 gap-6">
                <Card className="rounded-2xl">
                    <CardHeader>
                        <CardTitle>One Unified Platform</CardTitle>
                    </CardHeader>
                    <CardContent>
                        Manage leads, vehicles, deals, and service operations all from a single interface.
                        No more switching between outdated systems — IDSCRM brings it all together.
                    </CardContent>
                </Card>

                <Card className="rounded-2xl">
                    <CardHeader>
                        <CardTitle>Real-Time Communication</CardTitle>
                    </CardHeader>
                    <CardContent>
                        Live chat, presence, and video tools powered by Socket.IO and mediasoup let your
                        team and customers connect instantly — from any device.
                    </CardContent>
                </Card>

                <Card className="rounded-2xl">
                    <CardHeader>
                        <CardTitle>Dealer Tech Asset</CardTitle>
                    </CardHeader>
                    <CardContent>
                        We’re building dealer tech that adds value — not liability.
                        IDSCRM turns your data, leads, and transactions into growth assets.
                    </CardContent>
                </Card>


                  <Card className="rounded-2xl">
            <CardHeader>
              <CardTitle>Dealer Tech Asset</CardTitle>
            </CardHeader>
            <CardContent>
              IDSCRM turns dealership data into growth power — not technical debt.
            </CardContent>
          </Card>
            </section>
        </div>
    );
}
